'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import SearchBar, { type SearchBarFilters } from '@/components/Common/SearchBar'

/**
 * Home-page search bar. Instead of filtering in place, clicking the search
 * button navigates to the formations catalog carrying the current inputs:
 * the category becomes the route segment (/formations/[slug]) and the
 * remaining filters ride along as query params, which the catalog page
 * reads server-side to seed its filters.
 */
const HomeSearchBar: React.FC = () => {
    const router = useRouter()

    const handleSearch = (filters: SearchBarFilters) => {
        const params = new URLSearchParams()
        const keywords = filters.keywords.trim()
        if (keywords) params.set('keywords', keywords)
        if (filters.ville !== 'all') params.set('ville', filters.ville)
        if (filters.presentiel) params.set('presentiel', '1')
        if (filters.distance) params.set('distance', '1')

        const base = filters.category !== 'all' ? `/formations/${filters.category}` : '/formations'
        const query = params.toString()
        router.push(query ? `${base}?${query}` : base)
    }

    return <SearchBar onSearch={handleSearch} />
}

export default HomeSearchBar
